<div class="col-xl-9">
  <div class="card">
    <div class="card-body">
      <div class="border-bottom d-flex justify-content-between">
        <h3>Update CTC</h3>
        <h4>2/4</h4>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-xl-6">
          <div class="my-4">
            <label for="currentCtc" class="form-label">Current CTC</label>
            <input
              id="currentCtc"
              type="text"
              class="form-control"
              [placeholder]="currentCtcValue"
              disabled
            />
          </div>
          <form [formGroup]="form">
            <div class="my-4 d-flex justify-content-between">
              <div>
                <label for="percentIncrease" class="form-label">&percnt; Increase</label>
                <input
                  id="percentIncrease"
                  type="number"
                  class="form-control"
                  placeholder="&percnt;"
                  (input)="updateCtcAmount($event)"
                />
              </div>
              <div>
                <label for="revisedCtc" class="form-label"
                  >Revised CTC <span class="text-danger">*</span></label
                >
                <input
                  type="number"
                  id="revisedCtc"
                  class="form-control"
                  formControlName="ctc"
                  appIndianNumberInputFormat
                  appTrimInput
                  (input)="updatePercentage($event)"
                />
              </div>
            </div>
            <div *ngIf="this.currentMode !== salaryMode.UPDATE" class="my-4">
              <label for="effectiveFrom" class="form-label">
                Effective From <span class="text-danger">* </span>
              </label>
              <input
                id="effectiveFrom"
                type="date"
                class="form-control"
                formControlName="effectiveFrom"
                [min]="minEffectiveFromDate"
                (change)="validateEffectiveFromDate()"
                appTrimInput
              />
              <small
                class="text-danger"
                *ngIf="
                  form.get('effectiveFrom')?.touched &&
                  form.get('effectiveFrom')?.hasError('minDate')
                "
              >
                Effective From date cannot be earlier than
                {{ minEffectiveFromDate }}.
              </small>
            </div>
            <div *ngIf="this.currentMode !== salaryMode.UPDATE" class="my-4">
              <label for="payoutFrom" class="form-label"
                >PayOut From <span class="text-danger">* </span>
                <i
                  class="ti ti-info-circle text-info"
                  ngbTooltip="PayOut can't be less then Effective From or a Pay-Roll run month"
                  placement="right"
                ></i
              ></label>
              <input
                id="payoutFrom"
                type="month"
                class="form-control"
                formControlName="payoutFrom"
                appTrimInput
                [min]="minPayOutFromMonth$ | async"
              />
              <div *ngIf="form.get('ctc')?.errors?.['required']">
                <span class="text-danger">
                  {{ getErrorMessage('ctc') }}
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
